import classes from "./Footer.module.css";

const Footer = () => {
	return (
		<footer className={classes.footer}>
			<div>
				<a href="https://portfolio-page-react.web.app/">Return to portfolio</a>
			</div>
		</footer>
	);
};

export default Footer;
